import Axios from 'axios'
import { ICurrencyFilterParams } from 'models/UtilsFilters'
const urlBase = 'tablas'

export const getTableCurrencyApi = async (params: ICurrencyFilterParams) => {
	const response = await Axios.get(`${urlBase}/Monedas`, { params })
	return response.data
}
